export enum StepType {
  StepTypeS = "S",
  StepTypeD = "D",
}

export interface IWorkflowStep extends IWorkflowStepInput {
  id: number;
  workflowId: number;
  rowDate: Date;
  inUse?: boolean;
}

export interface IWorkflowStepInput {
  [key: string]: number | string | null | Date | boolean | undefined;

  stepName: string;
  stepNumber: number;
  workflowElementId: number | null;
  stepType: StepType | null;
  allowAttendantTransfer: boolean | null;
  startMessage: string;
  menuOption: string;
  workflowEngineId: number | null;
  messageBody: string;
  exceptionMessage: string;
  startMessageEngine: string;
  gotoWorkflowStepName: string | null;
  exceptionSourceWorkflowStepName: string | null;
  workflowPositionX: number;
  workflowPositionY: number;
  endMessageEngine: string;
  promptAIInputId?: number | null;
  promptAIExceptionId?: number | null;
  chatTransferAllowed?: boolean | null;
}
